<template>
  <v-card class="py-1 xs12 py-0 elevation-10" :class="!editModeCard ? 'flex md5 offset-md3' : 'px-4'">
    <v-card-title class="pa-0"></v-card-title>
    <v-card-text v-if="!editModeCard && activeUser">
      <img class="icon btn--round elevation-3 center-cropped-50 left mt-2 mr-1"
           :src="$helper.getLocation() + activeUser.img">
      <v-text-field class="flex md9 offset-md2 xs12 grey--text-field" :multiLine="true" :rows="rowsMultiline"
                    @click="editCard()" title="Post News"></v-text-field>
    </v-card-text>
    <v-form v-else="" v-model="valid">
      <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3 color="red" class="red--text">
          <v-text-field label="Title" v-model="comment.headline"
                        :rules="notEmpty"
                        required></v-text-field>
        </v-flex>


        <v-flex xs12 pa-2 grey>
          <v-text-field multiLine class="elevation-3 white pl-3 pr-3" color="indigo"
                        label="Text" v-model="comment.text"
                        :rules="notEmpty"
                        :counter="2000"
                        required></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-card-text v-if="editModeCard">
      <small>*indicates required field</small>
      <br>
      <small v-if="!valid" class="red--text darken-2 pa-1">
        <v-icon color="red">error</v-icon>
        Please fill out all fields
      </small>
    </v-card-text>
    <v-card-actions v-if="editModeCard" class="affix fixed-card-actions">
      <v-spacer></v-spacer>
      <v-btn color="grey darken-3" flat @click.native="editModeCard=false">Cancel</v-btn>
      <v-btn color="blue darken-3 elevation-5" class="elevation-5 grey lighten-3" flat
             @click="submit()"
             :disabled="!valid">Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import {mapActions} from 'vuex';

  export default{
    name: 'comments-dialog',
    props: ['activeUser', 'news_item'],
    data() {
      return {
        rowsMultiline: 1,
        notEmpty: [
          (v) => !!v || 'Field is required.',
        ],
        valid: false,
        editMode: false,
        editModeCard: false,
        comment: {
          user_id: this.activeUser.id,
          headline: '',
          text: '',
          news_ref_id: this.news_item.id,
          likes: '',
          likes_favorite: '',
        },
      };
    },
    methods: {
      ...mapActions(['getAllComments', 'updatePoints', 'setActiveComment', 'getAllNews']),
        editCard () {
          this.editModeCard = true;
            ga('send', {
                hitType: 'event',
                eventCategory: 'editComment',
                eventAction: 'edit',
                eventLabel: "Edit",
                eventValue: 100
            });
        },
      submit () {
          // console.log('submit')
        this.comment.updated_at = this.$helper.getTimeStamp();
        this.comment.created_at = this.$helper.getTimeStamp();
        this.$http.post(this.$helper.apiUrl()+'/content/news_comments', this.comment).then(
          () => {
            this.getAllComments(() => {
              this.setActiveComment(this.news_item.id);
              let cp = this.$helper.cpObj(this.news_item);
              cp.comments = parseInt(this.news_item.comments, 10) + 1;
              this.$http.put(`${this.$helper.apiUrl()}/content/news/${cp.id}`, cp).then(
                () => {
                  this.getAllNews();
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'addComment',
                        eventAction: 'edit',
                        eventLabel: "Edit",
                        eventValue: 300
                    });
                });
            });

            this.updatePoints({user_id: this.activeUser.id, points: 5});
          });
        this.editModeCard = false;
        this.comment.text = ''; this.comment.headline = '';
      },
      deleteComment (commentId) {
        this.$http.delete(this.$helper.apiUrl()+'/content/news_comments/' + commentId).then(
          () => {
            this.getAllComments();
          });
      },
      updateComments(){
      },
    },
  };
</script>
<style>
  .center-cropped-38 {
    object-position: center;
    width: 38px;
    height: 38px;
    background-position: center center;
    background-repeat: no-repeat;
  }
</style>
